import React, { forwardRef } from 'react';
import type { MouseEvent } from 'react';
import classnames from 'classnames';
import styles from './index.module.scss';

export type TabLabelProps = {
  name?: string;
  selected?: boolean;
  className?: string;
  onClick?: (e: MouseEvent<HTMLSpanElement>) => void;
};

const TabLabel = forwardRef<HTMLSpanElement, TabLabelProps>(({ name, selected, className, onClick }, ref) => {
  return (
    <span
      ref={ref}
      className={classnames(styles.label, { [styles['label--selected']]: selected }, className)}
      onClick={e => {
        onClick?.(e);
      }}
    >
      {name}
    </span>
  );
});

export default TabLabel;
